module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn-sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tuesday")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“You’re gonna be rich someday,” she said to the sailor.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“You see that in the cards?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Yes. I see a glittering treasure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“What else do you see?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She stared at the cards. Said nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Ma’am? What else do you see?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("She was young. Maybe twenty-five. A big nose but otherwise pretty. But then it was like she was turning into an old hag in front of his eyes. And then she became dust and blew away.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("He wasn’t in the tent anymore. Was outside somewhere in the dark. A storm was coming up. Lightning flashes, thuds of thunder. He felt lonely and scared like a little kid. He was afraid he was about to cry, then he actually did cry. More than just cry. He wept.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He woke. Eyes dry despite the dream. He heard the rhythmic swish of the waves like the boundless breathing of the dreamless sea and then sat up. Gazed out from Point Mugu. Fog shrouded the ocean. Seeming to meld with the gray water. It was dawn. It was chilly. He breathed with the waves slowly and deliberately, in through the nose and out through the mouth. His breath condensing. Adding his breaths to the greater gray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He got out of his Ultralite sleeping bag and walked off a bit and peed. His pee steaming. He was facing the gigantic mound of Mugu Rock. On the other side was the Pacific Coast Highway and on the other side of the highway another gigantic mound of rock that made the first mound look little. He had passed this way many years ago and been so struck by its sublime and ancient beauty he had vowed to come back some day and spend the night. To sleep in the rocky embrace of Point Mugu and see what dreams it brought him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took a bottle of water out of his rucksack and drank and then a box of raisins. On it the pretty Italian gal in the sunbonnet. He remembered her from when he was a kid and now he was grown yet here she still was. An ageless pagan raisin goddess. He walked over to the edge of the cliff and sat down. The beach was about thirty feet below. Configurations of rock rose up to nearly eye level. There was a bridge of rock that looked like it would be fun to walk across.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He opened the box of raisins. A sea bird cried and gyred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gray sat there chewing and watched the water.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("Deiter the Cheater, under the flapping pennants, amid the blazing windshields, looked across the highway. Buster’s was a yellow-brick building with neon beer signs in the window. He could see her moving around inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thinking about pussy?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Portly Wesley Beason was walking up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How’d you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You just had that thinking-about-pussy look on your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m gonna go get some lunch. Want anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Pie.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A whole pie or just a piece?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do I look like I could eat a whole pie? Don’t answer that. Just a piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What kind?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Any kind. As long as it’s banana cream.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deiter waited for a break in the traffic then walked across the highway. In his Zegna cream and gray-striped suit. He had high cheekbones and dark eyes that harked back to the Indian in him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took his usual table next to the window. She brought him over a glass of iced tea and a menu.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s good today?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The turkey loaf’s been popular.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll have that then.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wish all my customers were as easy as you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m just an easygoing guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He drank his iced tea and looked out the window at the "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DEITER “THE CHEATER” CHEATS FOR LESS")]), _vm._v(" sign and the big trucks passing on the highway. He sighed at the thought he’d be forty in a month and wondered what life was all about. He perked up when she came back with the turkey loaf.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I been sitting here trying to figure it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Figure what out?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The mystery of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed a little. “What mystery?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think there’s a damn big mystery. Just showing up here like you been dropped outa the sky.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ve told you. I came here to make a fresh start. People do it every day. There’s nothing mysterious about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But why here?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why not here?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So what did you do? Throw a dart at a map of the United States and it landed on Brady, Oklahoma?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe. You want some more iced tea?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He watched her tightly blue-jeaned hips sway away across the room. Her black hair falling on her shoulders. She came back with a pitcher and sluiced tea into his glass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bet you get asked out about a dozen times a day.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah. By "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I figure we’re in the same fix. You left your husband and my wife left me. And both of us are lonely.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I hear you’ve had a lot of wives.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Four. Is that a lot? Listen. Why don’t we drive up to Tulsa tonight? Have dinner in a real restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was used to getting a quick and definite no but instead she said nothing. He sat up a little straighter in his chair. Getting the feeling he got when he was about to sell a car. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("What can I do to make you my customer?")]), _vm._v(" is what he always asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You like seafood?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“White River Fish Market! Best seafood in the state!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s too late to get a babysitter.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bring your boy along. I love kids. I got five or six of ’em myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nah. I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come on, Gina. He who hesitates is lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gina smiled. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He grinned. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But it’s a school night. We don’t have time to go to Tulsa. Why don’t you just come to my place? I’ll cook you dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And I’ll eat it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Seven all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You better believe it’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("Wesley was sitting behind his desk doing paperwork. He cocked his head and gave Deiter a critical look as he walked in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where’s my pie?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Damn it, Rusty. I was looking forward to that pie.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll go right back over there and get you a piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No. Forget it. I don’t want it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well don’t sulk.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll sulk if I want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I got a date.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who with?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Angelina Jolie. Who do you think? Gina.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re shitting me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tonight. Dinner. Her place. Candlelight. Wine. Soft romantic music.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How come you’re the lucky one?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She musta heard about my twelve-inch pecker.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("She washed her hair with Bumble and Bumble shampoo. Put on some L’Oréal HiP lip gloss and Dior mascara. Plunged into her closet and came out with clothes unworn for years. But Luke was hanging around not looking like he liked it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Whatsamatter?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you have to do this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do what? I’m just having a friend over for dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a date. I can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do you know about dates? You’re ten years old for chrissake.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s called Deiter the Cheater.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He sells used cars, it’s a joke. Do you think if he really was a cheater he’d call himself the Cheater?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well he wouldn’t.” She sat down on the side of her bed and pulled him over. He stood there uncomfortably in her arms. “Look. You and me, we’ve gone through a lot together. I swear to God it’s gonna get better but right now we just have to make the best of it. I want you to be a normal kid as much as you can and for one night I’d just kinda like to feel normal too. Okay, so maybe this is kinda like a date. But he doesn’t represent any kind of threat to you and me. Nothing’ll ever be as important to me as you. You know that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Luke nodded. She brushed some hair away from his forehead then gave it a kiss. He turned away. Went to his room to play Halo. His favorite video game.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An autumnal cold front was moving through and the temperature dropped and it began to rain. Gina sipped red wine as she worked in the kitchen and she heard the rain and it made her sad. Fleetingly she had a sense of being outside herself and looking at her whole life. Seeing simultaneously Gina as a sad young woman and a sad little girl and a sad old lady. All three listening to the eternal rain. The doorbell rang right at seven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deiter came in smelling of cologne and bearing wine and flowers and with rain glittering in his hair. Maybe he was a little old for her but he really was nice-looking. Hard to tell what was under a suit but he seemed to have a lean fit body. To go along with a ton of cornball charm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was appropriately effusive over her appearance. Luke was summoned and introduced. Deiter gave him a gift: a Harry Potter flashlight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You like Harry Potter?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I like the movies. I haven’t ever read any of the books.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, I’m not much of a reader either. Probably hadn’t read a book cover to cover since "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bootlegger’s Boy.")]), _vm._v(" And that was twenty years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bootlegger’s Boy")]), _vm._v("?” said Gina.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Barry Switzer wrote it about his life. He was the Oklahoma football coach.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t say I didn’t like to read,” said Luke then he turned to his mother. “Could I go back to my room?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay. But we’ll be eating dinner soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They watched him leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well that went over like a lead balloon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He liked it. I could tell. He’s just shy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can relate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You can?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure. All this blinding self-confidence and charisma you see when you look at me? It’s just an act.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No kidding.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nope. Inside I’m just a bashful country boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She got him wine and sat him down in front of some smoked mozzarella and toasted bread and went back in the kitchen. The sauce was simmering and the water for the pasta was beginning to boil. The door opened and he came in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That sauce smells amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Secret family recipe?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, it’s just the usual. Garlic, onions, basil, parsley.” She started cutting up a tomato for the salad. “Sorry, I’m running late. I meant to have everything ready before you got here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hey I’m not in the least bit of a hurry. So how you liking life at the Osage Creek Apartments?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I lived here once for a brief while. When I was between marriages.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How come you’ve been married so many times?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Guess I just like getting married.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He set his glass of wine down on the counter and leaned back on it and folded his arms on his chest and crossed his ankles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I been thinking. Maybe you oughta cross the highway and sell cars for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You serious?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think you’d be good at it. You’re a good talker, you’re likeable, you got a good sense of humor. And it’s like my mother says—if you want the right man for a job hire a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks. But I think I’ll stick to waitressing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s what you’ve always done? Waitress?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What line of work was your husband in?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He was a businessman.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What kind of business?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He had his finger in a lot of different pies.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Kind of an entrepreneur type?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You could say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Peterson’s your married name I’ll bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why would you bet that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“’Cause you don’t seem like a Peterson.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do I seem like?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh I don’t know. Something more—exotic.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She laughed. “Oh yeah, I’m real exotic all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re exotic to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So how’d you get in the used-car business?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Inherited it from my daddy. He was Deiter the Cheater the First.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s okay. Sometimes it gets kinda old.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He walked over to her and put his hands on her waist. She looked over her shoulder and he kissed her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re about the prettiest thing to hit this town in fifty years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who came here fifty years ago?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know. Maybe some movie star had a flat tire. On her way back to Hollywood.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The doorbell rang. Gina frowned. “Who could that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Probably somebody selling something. I’ll go run ’em off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He walked across the living room with the taste of her on his lips and an extra bit of bounce in his step. The doorbell rang again. He opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The apartment was on the second floor at the top of a flight of stairs. A little winded from the walk up, a massively fat man stood outside under the glare of a yellow light. Twice as fat as Wesley. Dark curly hair wet with rain. Heavy black wool coat with rain on the shoulders. Red sweater and black pants. Hands stuck in the pockets of his coat. Looking about as much like a Buddhist monk as like a salesman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What can I do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is Gina here?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who wants to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m Toddo. Her cousin. From back east.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh her cousin!” he said as he opened the screen door and ushered him in. “She didn’t tell me you were coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man looked around the room. Deiter grinning at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“From back east are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man pointed past Deiter looking mildly puzzled. “What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deiter looked around. Saw nothing notable. Just a wall with a picture of a fox hunt on it. Horses and hounds and riders in red jackets and white pants. The first bullet didn’t kill him or even make him unconscious. He went down like a puppet whose strings had been cut then found himself looking at a bug’s-eye view of the carpet. Then the man shot twice more into Deiter’s brain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked over and saw the boy standing at the threshold of a hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hey Luke. Where’s your mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Luke didn’t move his head but without even meaning to he cut his eyes toward the kitchen. The man walked toward it. It had a swinging door and he pushed it open with his left hand. His right hand holding the silenced Ruger Mark II .22. A cascading mass of boiling water smacked him in the face. He screamed and fired blindly but not without purpose, his shots spaced regularly across the room. Gina heard the rounds ripping the air, one just to her left and then with a loud clang one hitting the pot and nearly knocking it out of her hands and one about an inch from her right ear. She swung the pot and hit him in the side of the head. He stopped screaming and dropped to his knees, his scalded head steaming. He started to raise the gun and she hit him again harder even than the first time. He dropped the gun and pitched forward and fell on it and didn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She dropped the pot and yelled for Luke and then he was there. A little wisp of a boy. Terror seeming to diminish him even more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He nodded staring at the man. “Who is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I got no idea. What happened to Rusty?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think he’s dead, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh god.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man was breathing heavily as though slumbering deeply. Blood leaked out on the floor through his curly hair. She grabbed the knife off the counter. Prepared to start stabbing him if he stirred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She wanted to get the gun that was buried under the three or four hundred pounds of Toddo. But moving him was like trying to turn over a water bed. They strained and gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mom, what should we do? Should we call 911?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She saw the white top of a piece of paper sticking out of his coat pocket. She pulled it out and unfolded it. It was a MapQuest printout giving directions from the Tulsa airport to her apartment. A phone number had been written on it. A number that she recognized.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shit!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mom, what’s wrong? What is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We gotta get outa here. Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked once at Deiter on the living room floor and didn’t look at him again. They had practiced this like a fire drill. Grabbing prepacked suitcases and their laptops. The goal to get out the door in under a minute. They clattered down the flight of stairs and fled into rain and night.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("Gray, his rucksack on his back, walked down Alejo Avenue. It was the main drag of the town. There wasn’t much to it. Some small businesses like a shoe repair store, a pet supplies store, a Pilates place, a liquor store and bait shop, a grocery store. A Mexican restaurant, an Italian restaurant, a coffee shop, bars named the Prince o’ Whales and the Harbor Room. Some two- and three-story apartment buildings. To the south, hills covered with big houses rose up steeply. To the north was a flat expanse of grassy wetlands that had somehow escaped the bulldozers of the developers. Straight ahead the street ended at sand dunes and the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was only about eight in the evening but already King Beach seemed to be getting ready to pack it in. Just a few other people on the sidewalks and an occasional car passing by. It seemed oddly untouristy and untrendy for a Southern California beach town. He heard a rumbling then suddenly a jetliner roared above the hills angling toward the sky. Taking off from LAX. Seeming nearly close enough for him to hit it with a rock.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A young guy was walking rapidly toward him talking on a cell phone. He was wearing a hooded sweatshirt that had "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("KALASHNIKOV")]), _vm._v(" across the front. On his forehead was a tattoo of a swastika with wings. A dog on a leash was walking beside him. Half malamute and half god knew what. It was just about the most pitiful dog Gray had ever seen. Only the ragged remnants of chewed-off-looking ears. His right eye scarred and sightless. Patchy brown and white fur stretched too tight over his sturdy frame. Wearing a punishment collar lined with inverted spikes. The guy never looked at Gray as they passed each other but the dog did. Gray looked over his shoulder and saw the dog looking back over "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("his")]), _vm._v(" shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A big wooden sea horse painted yellow was poised above the entrance of a blue stucco building. He lingered and looked in. Life was going on in there. The bar was crowded. A blond waitress carried a towering platter of orange king crab legs to a table. Gray went in as behind him another jetliner blasted into the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The decor was nets, tridents, seashells, and mounted fish. He sat down at the bar and ordered a draft beer. An old man next to him who didn’t seem to be able to move his neck turned his whole body to take a look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Isn’t it amazing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Isn’t what amazing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How Sam Snead could never win the Open.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gray had no idea who Sam Snead was but nodded anyway. He’d dropped his rucksack on the floor by his stool. The old man looked down at it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Traveling?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I guess so.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“To or from?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well that’s a good question.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The old man laughed as if Gray had given the only correct answer to some ancient mystic riddle. He stuck his hand out and Gray shook it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m Norman.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Gray.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a sad night, Gray. A very sad night.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Jones is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sorry to hear that.” He slurped up some beery foam. “Who was he?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“My cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How did he die?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Natural causes. Kidney failure. But it was basically old age. He was even older than me in cat years. I’ve found twenty-seven rubber bands over the last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where did you find them?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Here and there. Mostly just lying on the ground. It’s amazing how many rubber bands you see if you’re looking for them. So maybe you’re wondering why I bother to pick them up?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes sir. I was wondering that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t call me sir. Do you know what entropy is?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Something to do with physics?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s right. Entropy is the movement of all the matter and energy in the universe from a state of order to a state of disorder. It’s like a popsicle dropped on a sidewalk by a careless child on a hot summer day. Pretty soon it’s gonna be a sticky little puddle of nothing. The universe is like that popsicle. It’s melting and there’s not a damn thing we can do about it. It’s a process that can’t be stopped. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("However.")]), _vm._v(" It can be slowed down.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is that where picking up rubber bands comes in?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“My god, Gray. You’re way ahead of me. I’ll keep picking up rubber bands until I have maybe a couple of thousand. Then I’ll donate them to a school or something. The rubber bands will again be performing rubber band functions instead of just being trash on the street. In a small way, for a short while, entropy will be reversed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell you what, Norman. I’ll start keeping my eye out for rubber bands.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll tell "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" what. I’ll buy you a drink if you drink to Mr. Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You got a deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("The Honda Accord sped west on Interstate 40. Through the empty endless Texas night. Amarillo up ahead. Not that they were going to Amarillo. They were headed west merely because it was the opposite of east. Away from that malignant place out of which had issued the fat man in the red sweater.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Luke had always cried a lot for a boy and had been crying tonight but now was quiet. She glanced over at him. His face was turned away. She couldn’t tell if his eyes were open. Maybe he had slipped into the exhausted sleep of the desperate and lost.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The radio station she had been listening to was fading out and she looked for another. But she couldn’t seem to find anything but twangy country music and crazy preachers shouting about damnation. So she turned the radio off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was quiet except for the monotonous sounds of the car. She felt as isolated as if she and Luke were in some sealed capsule hurtling through the icy darkness of the farthest reaches of the Milky Way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at the digital clock on the dashboard. It said it was midnight.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 78
// module chunks = 0